import * as Sentry from '@sentry/react';

/**
 * Capture a mutation error in Sentry alongside a toast notification (LOK-167).
 *
 * Call from mutation `onError` callbacks to ensure silent failures (those that
 * only show a toast) are also reported to Sentry for visibility in production.
 *
 * @example
 * onError: (err) => {
 *   toast.error(parseApiError(err, 'Failed to create bot'));
 *   captureMutationError(err, { mutation: 'create_bot' });
 * }
 */
export function captureMutationError(
  err: unknown,
  tags: Record<string, string | number | undefined>,
): void {
  const filteredTags: Record<string, string | number> = {};
  for (const [k, v] of Object.entries(tags)) {
    if (v != null) filteredTags[k] = v;
  }
  Sentry.captureException(err, { tags: filteredTags });
}
